<template>
    <Dialog v-model="state" :scrollable="false" @close="$emit('close')">
        <div class="mobile-push" v-loading="loading">
            <div class="mobile-push__title">
                Рассылка Push-уведомлений
            </div>
            <div class="mobile-push__content">
                <ModelString
                    label="Заголовок"
                    v-model="formData.title"
                    :invalidateFunction="() => errors.title"
                    maxlength="50"
                    required
                />

                <ModelString
                    label="Текст push-уведомления"
                    v-model="formData.text"
                    :invalidateFunction="() => errors.text"
                    maxlength="125"
                    required
                    is-multiple-lines
                />

                <ModelString
                    label="Ссылка"
                    v-model="formData.link"
                    @change="updateLinkUrl"
                    :invalidateFunction="() => errors.link"
                />
            </div>
            <div class="mobile-push__footer">
                <button class="button button-blue button-outline" @click="$emit('close')">
                    Отменить
                </button>
                <button class="button button-blue" @click="submit" :disabled="!allowSubmit">
                    Отправить
                </button>
            </div>
        </div>
    </Dialog>
</template>

<script>
import Dialog from '@/components/UI/Dialog';
import ModelString from "@/components/UI/models/ModelString.vue";
import {isEmpty} from "@/tools/filters";

export default {
    name: "UserSearchNotificationPush",

    components: {
        ModelString,
        Dialog,
    },

    emits: [ "close", "submit" ],

    props: {
        loading: Boolean,
    },

    data: () => ({
        state: true,

        formData: {
            title: '',
            text: '',
            link: '',
        },
        errors: {
            title: '',
            text: '',
            link: '',
        },
    }),

    beforeMount() {
        this.state = true;
    },

    watch: {
        state(val) {
            if (!val) {
                this.$emit("close");
            }
        },
    },

    computed: {
        hasErrors() {
            return Object.keys(this.errors).filter(k => !isEmpty(this.errors[k])).length > 0;
        },
        allowSubmit() {
            return this.formData.title
                && this.formData.text
                && !this.hasErrors
            ;
        },
    },

    methods: {
        updateLinkUrl() {
            if (this.formData.link && !/^http(s)?:\/\//.test(this.formData.link)) {
                this.formData.link = `https://${this.formData.link}`;
            }
        },

        validate() {
            this.errors.title = this.formData.title.trim() === '' ? 'Введите заголовок' : '';
            this.errors.text = this.formData.text.trim() === '' ? 'Введите текст push-уведомления' : '';

            if (this.formData.link.trim() !== '') {
                try {
                    new URL(this.formData.link);
                } catch (_) {
                    this.errors.link = 'Невалидная ссылка';
                }
            } else {
                this.errors.link = '';
            }

            return !this.hasErrors;
        },

        submit() {
            if (this.validate()) {
                this.$emit("submit", this.formData);
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/variables';
@import '~@/styles/buttons_v2';

.mobile-push {
    padding: urem(12);
    display: flex;
    flex-direction: column;
    gap: urem(40);

    @include on-desktop {
        padding: 0;
        width: urem(540);
    }

    &__title {
        text-align: center;

        @include set-font-size(18, 700, 24);

        @include on-desktop {
            @include set-font-size(26, 700, 30);
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        gap: urem(12);
    }

    &__footer {
        display: flex;
        flex-direction: column-reverse;

        @include on-desktop {
            margin: 0 auto;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: urem(24);
        }

        .button {
            gap: urem(6);
            padding-left: urem(32);
            padding-right: urem(32);
            @include set-font-size(14, 600, 20);

            .icon {
                width: urem(20);
            }
        }
    }
}
</style>
